import { NIMBLY_API_SCHEDULES_LITE_V2 } from '../constants/api';
import { PopulatedQuestionnaireIndex, ScheduleTypes } from '../typing/types';
import { SelfieSignature } from '../utils/classes';
import moment from 'moment';
import API from '../store/helpers/api';
import { mapActiveScheduleToSiteScheduleInfos } from './scheduleMapper';

interface SiteScheduleInfo {
  key: string;
  hasDeadline: boolean;
  startTime: number;
  endTime: number;
  isScheduledToday: boolean;
  isDoneToday: boolean;
  unfinishedDates: string[];
  isQuestionnaireExists: boolean;
  questionnaireTitle: string;
  questionnaireDetails: { key: string; value: PopulatedQuestionnaireIndex };
  scheduledDates: {
    [date: string]: {
      isComplete: boolean;
    };
  };
  totalScheduled: number;
  totalCompleted: number;
  type: ScheduleTypes;
  emailTargets: string[];
  signatures: number;
  selfieSignatures: SelfieSignature[];
  hasAdhocCustom: boolean;
  yesterdayActiveScheduleCount?: number;
  yesterdayActiveCompleteCount?: number;
}
interface UserSiteSchedulePayload {
  startDate: string;
  endDate: string;
  etag: string | null;
}
interface UserSingleSiteSchedulePayload extends UserSiteSchedulePayload {
  siteID: string;
}

export const getUserSingleSiteSchedule = async (
  payload: UserSingleSiteSchedulePayload
): Promise<SiteScheduleInfo[]> => {
  let siteSchedules: SiteScheduleInfo[] = [];
  try {
    let { siteID, startDate, endDate } = payload;

    // Limit due to performance issue
    const endDateMoment = moment(endDate);
    const startDateMoment = moment(startDate);
    if (endDateMoment.diff(startDateMoment, 'months') > 1) {
      startDate = moment().subtract(30, 'days').format('YYYY-MM-DD');
      endDate = moment().add(30, 'days').format('YYYY-MM-DD');
    }

    const formattedStartDate = moment(startDate).locale('en').format('YYYY-MM-DD');
    const formattedEndDate = moment(endDate).locale('en').format('YYYY-MM-DD');

    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const qs = API.makeQueryString({
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      timezone,
      sites: siteID
    });
    const api = await API.withToken();
    const res = await api.getJSON(`${NIMBLY_API_SCHEDULES_LITE_V2}?${qs}`);
    if (res?.data) {
      siteSchedules = mapActiveScheduleToSiteScheduleInfos(res.data, siteID);
    }
  } catch (error) {}
  return siteSchedules;
};

export type { SiteScheduleInfo, UserSiteSchedulePayload, UserSingleSiteSchedulePayload };
